import {createAction} from "redux-act";
import {IFetchTeamStatistics, IRoundReducer, ISquadReducer, ITeamStatistics, IPrizesPopup} from "modules/types";

export const fetchRoundsAction = createAction();
export const fetchRoundSuccessAction = createAction<IRoundReducer>();

export const fetchSquadsAction = createAction();
export const fetchSquadsSuccessAction = createAction<ISquadReducer>();

export const fetchTeamStatistics = createAction<IFetchTeamStatistics>();
export const fetchTeamStatisticsSuccess = createAction<ITeamStatistics>();
export const clearTeamStatistics = createAction();

export const fetchPrizesPopup = createAction<string>();
export const fetchPrizesPopupSuccess = createAction<IPrizesPopup[]>();
export const fetchPrizesPopupFailed = createAction();
